<template>
  <v-container fluid>
    <v-dialog 
      v-model = "createCampaignDialog" 
      width="500">
      <v-card class="border-radius-standard">
        <v-card-title
          class="headline"
          primary-title
          style="font-size: 28px">
          {{ selected && selected.length && selected.length === 1 ? 'Rename Campaign' : 'Create New Campaign' }}
           <v-spacer />
           <v-icon @click="createCampaignDialog = false">close</v-icon>
        </v-card-title>
        <v-card-text>
          <add-campaign
            ref = "addCampaign"
            :put = "selected && selected.length && selected.length === 1 ? selected[0] : null"
            @loading = "addButtonLoader = $event"
            @success = "handleAddCampaign">
              <label slot = "before-name" class="black--text" style="font-size: 16px">Campaign Name</label>
              <label slot = "before-channel" class="black--text" style="font-size: 16px">Message Type</label>
              <label slot = "before-app" class="black--text" style="font-size: 16px">Sender Number</label>
              <label slot = "before-template" class="black--text" style="font-size: 16px">Template Message</label>
          </add-campaign>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            outline
            @click="createCampaignDialog = false">
            Cancel
          </v-btn>
          <v-btn
            :loading = "addButtonLoader"
            color="primary"
            @click="addNewCampaign">
            {{ selected && selected.length && selected.length === 1 ? 'Rename' : 'Create' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog 
      v-model = "deleteCampaignDialog" 
      width="400">
      <v-card v-if = "selected && selected.length" class="border-radius-standard">
        <v-card-title
          class="headline"
          primary-title>
          Delete {{ selected.map(campaign => campaign.name).join(', ') }}
        </v-card-title>
        <v-card-text>
          Are you sure you want to delete this Campaign?
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color = "black"
            outline
            @click="deleteCampaignDialog = false">
            Cancel
          </v-btn>
          <v-btn
            :loading = "addButtonLoader"
            color="error"
            @click="deleteCampaigns">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout 
      row 
      wrap>
      <h1>My Campaigns</h1>
      <v-spacer />
    </v-layout>
    <v-flex xs12>
    </v-flex>
    <v-flex xs12>
      <v-card class = "card-curvey">
        <v-layout 
          row 
          wrap>
          <v-flex xs4>
            <v-text-field
              v-model = "queries.q"
              placeholder = "Search by Name, Whatsapp or State.."
              campaignend-icon = "search"
              outline />
          </v-flex>
          <v-spacer />
          <v-btn
            :loading = "!!(addButtonLoader && !selected.length)"
            color = "blue-grey"
            class = "nlp-nav-btn"
            small
            outline
            @click = "openAddDialog(true)">
            <v-icon>add</v-icon>
            New Campaign
          </v-btn>

        </v-layout>
        <v-flex xs12>
          <v-data-table
            :headers="headers"
            :items="queriedCampaigns"
            item-key="name"
            no-data-text = "No Campaigns Available"
            class="elevation-1 nlp-data-table">
            <template 
              slot="items" 
              slot-scope = "props" > 
              <tr 
                v-if = "props.index === 0 && !props.item.name" 
                class = "text-center" 
                style="width: 100%">
                <td /><td /><td /><td class="text-center">No Campaigns Available</td><td /><td />
              </tr>
              <tr v-if = "props.item.name">
                <td>
                  <span
                    class = "primary--text pointer-cursor"
                    @click = "selectCampaign(props.item)">
                    {{ props.item.name }}
                  </span>
                </td>
                <td class="text-center">
                  {{ props.item.app.phone_number }}
                </td>
                <td class="text-center">{{ props.item.total_receivers }}</td>
                <td
                	:class="[
                		'text-center',
                		{ 'purple--text': props.item.status === 'DRAFT' },
                    { 'red--text': props.item.status === 'REJECTED' },
                		{ 'green--text': props.item.status === 'SENT' },
                		{ 'amber--text': props.item.status === 'SCHEDUALED' },
                	]"
                	style="text-transform: capitalize">
                	{{ props.item.status ? props.item.status.toLowerCase() : '' }}
                </td>
                <td class="text-center">{{ props.item.updated_at ? $moment(props.item.updated_at).format('D/M/YYYY H:m A') : 'N/A'  }}</td>
                <td style="display: flex; justify-content: flex-end; align-items: center; padding-right: 0 !important;">
                	<v-tooltip bottom  v-if="['DRAFT', 'SCHEDUALED', 'CANCELED'].indexOf(props.item.status) !== -1">
                		<template v-slot:activator="{ on }">
                			<v-btn
                        v-on="on"
                        class="px-3 campaigns-small-actions-btn" 
                        :to="`/campaigns/${props.item._id}/editor`">
                				<v-icon class="campain-small-action-icon">edit</v-icon>
                			</v-btn>
                		</template>
                		<span>Edit</span>
                	</v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }" v-if="['DRAFT', 'SCHEDUALED', 'CANCELED'].indexOf(props.item.status) === -1">
                      <v-btn v-on="on" class="px-3 campaigns-small-actions-btn" :to="`/campaigns/${props.item._id}/overview`">
                        <v-icon class="campain-small-action-icon">remove_red_eye</v-icon>
                      </v-btn>
                    </template>
                    <span>View</span>
                  </v-tooltip>
                	<v-tooltip bottom v-if="['CANCELED'].indexOf(props.item.status) === -1">
                		<template v-slot:activator="{ on }">
                			<v-btn v-on="on" class="px-3 campaigns-small-actions-btn" @click="initCopyCampaign(props.item)">
                				<v-icon class="campain-small-action-icon">content_copy</v-icon>
                			</v-btn>
                		</template>
                		<span>Copy</span>
                	</v-tooltip>
                  <v-tooltip bottom v-if="['SENT', 'SCHEDUALED', 'SENDING'].indexOf(props.item.status) === -1">
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" class="px-3 campaigns-small-actions-btn" @click="initDeleteCampaign(props.item)">
                        <span class="botter-trash-icon campain-small-action-bot-icon" style="color: #7F7F7F;" />
                      </v-btn>
                    </template>
                    <span>Delete</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-card>
    </v-flex>
        </v-layout>
  </v-container>
</template>

<script>
import AddCampaign from '@/components/campaign-manager/campaigns-crud/AddCampaign.vue'
import SupportedPlatforms from '@/components/block-build/blocks/SupportedPlatforms.vue'
export default {
  name: 'CampaignList',
  components: {
    AddCampaign,
    SupportedPlatforms
  },
  data() {
    return {
      queries: {
        q: ''
      },
      createCampaignDialog: false,
      deleteCampaignDialog: false,
      addButtonLoader: false,
      selected: [],
      headers: [
        {
          text: 'Campaign Name',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'WhatsApp App', value: 'app', align: 'center', sortable: false },
        { text: 'Number Of Recievers', value: 'count', align: 'center', sortable: false },
        { text: 'State', value: 'status', align: 'center', sortable: false },
        { text: 'Send In', value: 'actions', align: 'center', sortable: false },
        { text: 'Actions', value: 'actions', align: 'right', sortable: false },
      ]
    }
  },
  computed: {
    queriedCampaigns() {
      return this.$store.getters['campaigns/query'](this.queries.q)
    }
  },
  watch: {
    selected: {
      deep: true,
      handler(val) {
        if(val && val.length && val.length > 1) {
          this.selected = [val[val.length - 1]]
        }
      }
    }
  },
  mounted() {
    // get campaigns
    this.getCampaigns()
    if(this.$route.query.cb && this.$route.query.cb === 'add') {
      this.openAddDialog(true)
    }
  },
  methods: {
    getCampaigns() {
      this.$store.dispatch('campaigns/get', null).catch(err => {
        this.$store.dispatch('setErrorMessage', true)
      })
    },
    openAddDialog(reset = true) {
      if(reset)
        this.selected = []
      this.createCampaignDialog = true
    },
    addNewCampaign() {
      if (this.$refs.addCampaign) this.$refs.addCampaign.submit()
    },
    initEditCampaign(campaign) {
    	this.selected = [campaign]
    	this.openAddDialog(false)
    },
    initCopyCampaign(item) {
      this.$http_chat.post(
        `/campaigns/${item._id}/clone`,
        { name: `${item.name} - Copy` })
      .then(res => {
        this.$store.dispatch('setSnackbar', {
            text: `Cloned Successfully`,
            color: 'success'
      })
        this.getCampaigns()
      }).catch(err => {
        this.$store.dispatch('setErrorMessage', true)
        this.$store.dispatch('setLoader', false)
      })
     //  let inits = this.queriedCampaigns.filter(i => i._id === item._id)[0]
     //  inits.name = `${inits.name} - Copy`
     //  this.$_.pick(inits, ['name', 'channel', 'message_type', 'app', 'message'])
    	// this.openAddDialog(true)
    	// setTimeout(()=>{ this.$root.$emit('add-campaign-inits', inits) }, 500)
    },
    handleAddCampaign(e) {
      this.createCampaignDialog = false
      this.$router.push(`/campaigns/${e._id}/editor`)
    },
    selectCampaign(campaign) {
      this.$store.dispatch('campaigns/select', campaign)

      if (campaign.status !== 'DRAFT' && campaign.status !== 'SCHEDULED') {
        this.$router.push(`/campaigns/${campaign._id}/overview`)
      } else {
        this.$router.push(`/campaigns/${campaign._id}/editor`)
      }
    },
    initDeleteCampaign(campaign) {
    	this.selected = [campaign]
    	this.deleteCampaignDialog = true
    },
    deleteCampaigns() {
      this.$store.dispatch('setLoader', true)
      this.$store
        .dispatch('campaigns/delete/single', this.selected[0]._id)
        .then(() => {
          this.$store.dispatch('setSnackbar', {
            text: `Deleted Successfully`,
            color: 'success'
          })
          this.selected = []
          this.$store.dispatch('setLoader', false)
          this.deleteTemplateMessageDialog = false
        })
        .catch((err) => {
          // console.log(err)
          this.$store.dispatch('setErrorMessage', true)
          this.$store.dispatch('setLoader', false)
        })
    }
  }
}
</script>

<style lang="scss" src="@/assets/sass/commponents/nlp.scss" />
<style lang="scss">
.campaigns-small-actions-btn {
	height: 24px;
	width: 24px;
	max-width: 24px;
	min-width: 24px;
	border-radius: 3px !important;
	margin-left: 2px;
}
.campain-small-action-icon {
	font-size: 16px !important;
	margin-left: 4px;
  color: #7F7F7F !important;
}
.campain-small-action-bot-icon {
	font-size: 16px !important;
}
</style>
